import AcropolisIcon from "./AcropolisIcon.vue";
import BloomingPlantsIcon from "./BloomingPlantsIcon.vue";
import BlossomIcon from "./BlossomIcon.vue";
import BookIcon from "./BookIcon.vue";
import BreadIcon from "./BreadIcon.vue";
import BycicleIcon from "./BycicleIcon.vue";
import CameraIcon from "./CameraIcon.vue";
import CarIcon from "./CarIcon.vue";
import CircleIcon from "./CircleIcon.vue";
import ClayPotIcon from "./ClayPotIcon.vue";
import ClipboardIcon from "./ClipboardIcon.vue";
import ControllerIcon from "./ControllerIcon.vue";
import CouchIcon from "./CouchIcon.vue";
import CrossRoadsIcon from "./CrossRoadsIcon.vue";
import CutleryIcon from "./CutleryIcon.vue";
import DancingCoupleIcon from "./DancingCoupleIcon.vue";
import DicesIcon from "./DicesIcon.vue";
import DottedCircleIcon from "./DottedCircleIcon.vue";
import DoubleNoteIcon from "./DoubleNoteIcon.vue";
import EarthIcon from "./EarthIcon.vue";
import EthernetGlobeIcon from "./EthernetGlobeIcon.vue";
import GeometricFormsIcon from "./GeometricFormsIcon.vue";
import GlobeWithAcademicCapIcon from "./GlobeWithAcademicCapIcon.vue";
import HeartAndDotIcon from "./HeartAndDotIcon.vue";
import HouseIcon from "./HouseIcon.vue";
import IncreasingChartsIcon from "./IncreasingChartsIcon.vue";
import InkPenIcon from "./InkPenIcon.vue";
import MedKitIcon from "./MedKitIcon.vue";
import MotorcycleIcon from "./MotorcycleIcon.vue";
import MovieCameraIcon from "./MovieCameraIcon.vue";
import NecktieIcon from "./NecktieIcon.vue";
import NoteIcon from "./NoteIcon.vue";
import NoteWithSparklesIcon from "./NoteWithSparklesIcon.vue";
import PacmanIcon from "./PacmanIcon.vue";
import PawIcon from "./PawIcon.vue";
import PeaceIcon from "./PeaceIcon.vue";
import PencilIcon from "./PencilIcon.vue";
import PeopleIcon from "./PeopleIcon.vue";
import PlantIcon from "./PlantIcon.vue";
import ProcessorIcon from "./ProcessorIcon.vue";
import RadioIcon from "./RadioIcon.vue";
import SmartphoneIcon from "./SmartphoneIcon.vue";
import SmileyIcon from "./SmileyIcon.vue";
import SmileyOpenMouthIcon from "./SmileyOpenMouthIcon.vue";
import SoundWaveIcon from "./SoundWaveIcon.vue";
import SpeechBubblesIcon from "./SpeechBubblesIcon.vue";
import SteamIcon from "./SteamIcon.vue";
import StudyBookIcon from "./StudyBookIcon.vue";
import SubwooferIcon from "./SubwooferIcon.vue";
import TableBellIcon from "./TableBellIcon.vue";
import TextIcon from "./TextIcon.vue";
import TheatreMasksIcon from "./TheatreMasksIcon.vue";
import TicketsIcon from "./TicketsIcon.vue";
import TVIcon from "./TVIcon.vue";
import UwuIcon from "./UwuIcon.vue";
import WineGlassIcon from "./WineGlassIcon.vue";
import WrenchIcon from "./WrenchIcon.vue";

export default {
    AcropolisIcon,
    BloomingPlantsIcon,
    BlossomIcon,
    BookIcon,
    BreadIcon,
    BycicleIcon,
    CameraIcon,
    CarIcon,
    CircleIcon,
    ClayPotIcon,
    ClipboardIcon,
    ControllerIcon,
    CouchIcon,
    CrossRoadsIcon,
    CutleryIcon,
    DancingCoupleIcon,
    DicesIcon,
    DottedCircleIcon,
    DoubleNoteIcon,
    EarthIcon,
    EthernetGlobeIcon,
    GeometricFormsIcon,
    GlobeWithAcademicCapIcon,
    HeartAndDotIcon,
    HouseIcon,
    IncreasingChartsIcon,
    InkPenIcon,
    MedKitIcon,
    MotorcycleIcon,
    MovieCameraIcon,
    NecktieIcon,
    NoteIcon,
    NoteWithSparklesIcon,
    PacmanIcon,
    PawIcon,
    PeaceIcon,
    PencilIcon,
    PeopleIcon,
    PlantIcon,
    ProcessorIcon,
    RadioIcon,
    SmartphoneIcon,
    SmileyIcon,
    SmileyOpenMouthIcon,
    SoundWaveIcon,
    SpeechBubblesIcon,
    SteamIcon,
    StudyBookIcon,
    SubwooferIcon,
    TableBellIcon,
    TextIcon,
    TheatreMasksIcon,
    TicketsIcon,
    TVIcon,
    UwuIcon,
    WineGlassIcon,
    WrenchIcon,
};
